import React from "react";
import { array, func } from "prop-types";

import MenuItem from "../../atoms/menu-item";

import "./menu-items.m.css";

const MenuItems = ({ menuItems, onClick }) => (
  <div styleName="wrapper">
    {menuItems.map((item, index) => (
      <MenuItem key={index} item={item} onClick={onClick} />
    ))}
  </div>
);

MenuItems.propTypes = {
  menuItems: array,
  onClick: func
};

export default MenuItems;
